import CaladreTheme from "theme/Theme";
import HomeBackgroundImage from "assets/images/freedom-2218616_1920.jpg";

const classes = {
  root: {
    minHeight: "70vh",
    justifyContent: "flex-start",
    "& .MuiCardContent-root:last-child": {
      paddingBottom: CaladreTheme.spacing(2),
    },
  },
  calendrier: {
    "& .rmdp-wrapper.single .rmdp-day.rmdp-range": {
      backgroundColor: "transparent",
      "& span": {
        backgroundColor: "rgba(22, 121, 138, 0.4)",
      },
    },
    "& .rmdp-wrapper": {
      boxShadow: "0 0 2px #8798ad",
      borderRadius: "18px !important",
      "& .rmdp-header-values span": {
        fontWeight: "bolder",
        fontSize: 12,
      },
      "& .rmdp-day": {
        height: "25px",
        width: "40px",
        padding: "5px",
        margin: "5px 0",
      },
      "& .rmdp-day span": {
        backgroundColor: CaladreTheme.custom.Gray2,
        height: "25x",
        width: "25px",
        fontSize: "10px",
        position: "absolute",
        top: "0",
        left: "0",
        right: "0",
        bottom: "0",
        margin: "auto",
      },
      "& .rmdp-day.rmdp-today span": {
        backgroundColor: CaladreTheme.custom.Gray2,
        color: CaladreTheme.custom.Black,
      },
      "& .rmdp-day.rmdp-range.start": {
        borderBottomLeftRadius: "50%",
        borderTopLeftRadius: "50%",
        background: "linear-gradient(90deg, transparent 50%, #16798A44 50%)",
      },
      "& .rmdp-day.rmdp-range.end": {
        borderBottomRightRadius: "50%",
        borderTopRightRadius: "50%",
        background: "linear-gradient(90deg, #16798A44 50%, transparent 50%)",
      },
      "& .rmdp-day.rmdp-range.start.end": {
        background: "none",
      },
      "& .rmdp-day.rmdp-range": {
        boxShadow: "none",
        backgroundColor: "#16798A44",
        "& span": {
          backgroundColor: CaladreTheme.palette.secondary.main,
          color: CaladreTheme.custom.Black,
        },
        "&.start span, &.end span": {
          backgroundColor: CaladreTheme.palette.primary.main,
          color: CaladreTheme.custom.White,
        },
      },
      "& .rmdp-day.rmdp-range span": {
        backgroundColor: "transparent",
      },
      "& .rmdp-arrow": {
        borderColor: CaladreTheme.custom.Black,
      },
      "& .rmdp-week-day": {
        color: "#002B60",
        fontFamily: "PoppinsSemiBold, sans-serif",
        fontSize: "10px",
      },
      "& .rmdp-arrow-container": {
        backgroundColor: "transparent",
        boxShadow: "none",
      },
      ".rmdp-day:not(.rmdp-disabled):not(.rmdp-day-hidden) span:hover": {
        backgroundColor: "rgba(22, 121, 138, 0.4)",
      },
    },
  },
  homeMainContainer: {
    background: "fixed",
    backgroundImage: `url(${HomeBackgroundImage})`,
    backgroundAttachment: "scroll",
    backgroundSize: "cover",
    backgroundPosition: "center center",
    display: "flex",
    justifyContent: "center !important",
    alignItems: "center",
    height: "100%",
    width: "100%",
    flexDirection: "column",
    [CaladreTheme.breakpoints.up("lg")]: {
      height: "calc(100vh - 80px)",
    },
  },
  homeContainer: {
    position: "relative",
    [CaladreTheme.breakpoints.down("lg")]: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
    },
  },
  fullWidth: {
    width: "100% !important",
  },
  destinationsBloc: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    marginTop: 1,
    marginBottom: 1,
    "& .MuiCard-root": {
      borderRadius: "12px",
      "& .MuiCardContent-root": {
        padding: CaladreTheme.spacing(3),
      },
      "& .MuiCardActions-root": {
        padding: "0 24px 24px 24px",
        "& a": {
          textDecoration: "none",
        },
      },
    },
    "& > .MuiButton-root": {
      marginTop: CaladreTheme.spacing(4),
    },
  },
  destinationBloc: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    marginTop: CaladreTheme.spacing(4),
    marginBottom: CaladreTheme.spacing(4),
    "& .MuiSvgIcon-root": {
      marginLeft: CaladreTheme.spacing(0.8),
    },
    "& .MuiTypography-root": {
      marginTop: CaladreTheme.spacing(3),
      marginBottom: CaladreTheme.spacing(3),
    },
  },
  destinationContent: {
    marginTop: CaladreTheme.spacing(4),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  appBar: {
    height: "80px",
    backgroundColor: CaladreTheme.custom.White,
    boxShadow: "none",
  },
  bigTitle: {
    display: "block",
    textAlign: "center",
    "& .MuiTypography-root": {
      marginTop: CaladreTheme.spacing(3),
      marginBottom: CaladreTheme.spacing(3),
      lineHeight: "1.167",
      textShadow: "1px 1px 4px black",
    },
    [CaladreTheme.breakpoints.up("lg")]: {
      "& .MuiTypography-root": {
        marginTop: CaladreTheme.spacing(5),
        marginBottom: CaladreTheme.spacing(5),
        lineHeight: "1.167",
        letterSpacing: "-0.01562em",
        textShadow: "1px 1px 4px black",
      },
    },
    [CaladreTheme.breakpoints.down("sm")]: {
      "& .MuiTypography-root": {
        fontSize: "18px",
      },
    },
  },
  mainTabsPanel: {
    marginBottom: CaladreTheme.spacing(25),
    [CaladreTheme.breakpoints.down("lg")]: {
      width: "90vw",
      marginTop: 0,
    },
  },
  tabBtn: {
    fontFamily: "PoppinsRegular,sans-serif",
    borderTopLeftRadius: "15px",
    borderTopRightRadius: "15px",
    textTransform: "initial",
    color: CaladreTheme.custom.White,
    backgroundColor: CaladreTheme.palette.secondary.main,
    [CaladreTheme.breakpoints.up("lg")]: {
      paddingRight: CaladreTheme.spacing(5),
    },
    "&:nth-of-type(even)": {
      backgroundColor: CaladreTheme.palette.primary.main,
    },
    "&.Mui-selected": {
      color: CaladreTheme.palette.primary.main,
      fontWeight: '800',
      backgroundColor: "rgba(255, 255, 255, 0.9)",
    },
  },
  card: {
    borderTopLeftRadius: "0",
    borderTopRightRadius: "15px",
    borderBottomRightRadius: "15px",
    borderBottomLeftRadius: "15px",
    backgroundColor: "rgba(255, 255, 255, 0.9)",
    "& .MuiCardContent": {
      padding: CaladreTheme.spacing(3),
      maxWidth: '100000px !important'
    },
    "& .MuiCardContent-root": {
      padding: CaladreTheme.spacing(3),
      maxWidth: '100000px !important'
    },
    [CaladreTheme.breakpoints.up("lg")]: {
      borderTopLeftRadius: 0,
      minWidth: "450px",
    },
  },
  specialCard: {
    borderRadius: "12px",
    backgroundColor: CaladreTheme.custom.Gray,
    "& .MuiGrid-item:not(:last-child)": {
      m: CaladreTheme.spacing(0, 2),
      borderBottom: `1px solid ${CaladreTheme.palette.primary.main}`,
    },
    "& .MuiCardContent": {
      padding: CaladreTheme.spacing(3),
    },
  },
  centered: {
    textAlign: "center",
  },
  label: {
    fontSize: "16px",
    marginBottom: CaladreTheme.spacing(1),
    color: CaladreTheme.palette.primary.main,
  },
  fieldBtn: {
    marginBottom: CaladreTheme.spacing(0),
    padding: CaladreTheme.spacing(0),
    fontWeight: "bold",
    color: CaladreTheme.palette.primary.main,
    fontSize: "14px",
    background: "none",
    "&:hover": {
      background: "none",
      borderColor: "transparent",
    },
    [CaladreTheme.breakpoints.down("xl")]: {
      fontSize: "11px",
    },
    [CaladreTheme.breakpoints.down("lg")]: {
      justifyContent: "start",
      width: "100%",
      margin: CaladreTheme.spacing(0.8, 0),
      padding: CaladreTheme.spacing(1, 1),
      border: "none",
      borderRadius: "12px",
      backgroundColor: CaladreTheme.custom.Gray,
      "&:hover": {
        border: "none",
        color: "black",
        backgroundColor: CaladreTheme.custom.Gray,
      },
      "& .MuiTypography-body1": {
        marginLeft: CaladreTheme.spacing(0.5),
        fontSize: "11px",
      },
    },
    [CaladreTheme.breakpoints.down("md")]: {
      "& .MuiTypography-body1": {
        fontSize: "10px",
      },
    },
  },
  linkBtn: {
    textDecoration: "underline",
    "&:hover": {
      background: "none",
      borderColor: "transparent",
    },
  },
  linkBtnThin: {
    px: 0,
    fontFamily: "PoppinsRegular,sans-serif",
    textDecoration: "underline",
    "&:hover": {
      textDecoration: "underline",
      background: "none",
      borderColor: "transparent",
    },
  },
  backBtn: {
    p: 0,
    fontSize: "14px",
    fontFamily: "PoppinsRegular,sans-serif",
    "&:hover": {
      background: "none",
      borderColor: "transparent",
    },
  },
  skipStep: {
    px: 0,
    fontSize: "12px",
    color: CaladreTheme.custom.Black,
    fontFamily: "PoppinsSemiBold,sans-serif",
    textDecoration: "underline",
    "&:hover": {
      color: CaladreTheme.custom.Black,
      textDecoration: "underline",
      background: "none",
      borderColor: "transparent",
    },
  },
  filterBtn: {
    margin: CaladreTheme.spacing(1, 0.5),
    borderRadius: "12px",
    fontSize: "10px",
    color: CaladreTheme.custom.Black,
    boxShadow: 3,
    "&:hover": {
      background: "none",
      borderColor: "transparent",
    },
  },
  moreBtn: {
    fontSize: { xs: "16px", md: "18px !important" },
    textDecoration: "underline",
    color: CaladreTheme.custom.Black,
    marginTop: { xs: "8px" },
    "&:hover": {
      background: "none",
      borderColor: "transparent",
    },
  },
  link: {
    padding: 0,
    textDecoration: "none",
    "&:hover": {
      textDecoration: "none",
    },
  },
  searchBtn: {
    backgroundColor: CaladreTheme.palette.primary.main,
    height: "100%",
    width: "100%",
    [CaladreTheme.breakpoints.up("lg")]: {
      borderBottomLeftRadius: "0",
      borderTopLeftRadius: "0",
    },
    "& .MuiSvgIcon-root": {
      color: CaladreTheme.custom.White,
    },
    "&:hover": {
      backgroundColor: CaladreTheme.palette.primary.main,
    },
  },
  onlyDesktop: {
    display: "none",
    [CaladreTheme.breakpoints.up("lg")]: {
      display: "block",
    },
  },
  onlyMobile: {
    display: "none",
    [CaladreTheme.breakpoints.down("lg")]: {
      display: "block",
    },
  },
  btnStyle: {
    fontSize: "12px",
    fontWeight: "bold",
    px: 0,
    border: "none",
    color: CaladreTheme.custom.Black,
    "&:hover": {
      border: "none",
    },
  },
  linkButton: {
    textDecoration: "none",
    marginTop: "16px",
    marginBottom: "16px",
    padding: "0 5px",
    "&:nth-of-type(2)": {
      borderRight: "1px solid black",
      borderLeft: "1px solid black",
    },
  },
  mobileLinkButton: {
    display: "flex",
    padding: "16px 8px",
    fontFamily: "PoppinsSemiBold, sans-serif",
    color: CaladreTheme.palette.primary.main,
  },
  profilsBloc: {
    display: "block",
    marginTop: CaladreTheme.spacing(6),
    marginBottom: CaladreTheme.spacing(6),
    "& .MuiCard-root": {
      display: "flex",
      borderRadius: "12px",
      "& .MuiCardMedia-root": {
        width: 180,
        height: 120,
        transition: "all 0.2s ease-in-out",
        "&:hover": {
          transform: "scale(1.05)",
        },
        [CaladreTheme.breakpoints.down("md")]: {
          width: "100px",
          height: "auto",
        },
      },
      "& .MuiGrid-container": {
        display: "flex",
        alignItems: "center",
        justifyContent: "start",
        "&:hover": {
          cursor: "pointer",
          backgroundColor: "#E8E7E7",
        },
        "& .MuiGrid-item:first-of-type": {
          "& :first-child": {
            fontSize: "16px",
          },
          "& :nth-of-type(2)": {
            fontSize: "12px",
          },
          "& :nth-of-type(3)": {
            display: "flex",
            alignItems: "center",
            fontSize: "12px",
            fontFamily: "PoppinsSemiBold, sans-serif",
          },
          [CaladreTheme.breakpoints.down("lg")]: {
            "& :first-child": {
              fontSize: "14px",
            },
            "& :nth-of-type(2)": {
              fontSize: "10px",
            },
            "& :nth-of-type(3)": {
              fontSize: "9px",
            },
          },
        },
        "& .MuiGrid-item:nth-of-type(2) .MuiTypography-root ": {
          fontFamily: "PoppinsRegular, sans-serif",
          color: CaladreTheme.custom.Black,
        },
        "& .MuiGrid-item": {
          justifyContent: "start",
          padding: CaladreTheme.spacing(0, 2),
          "& .MuiListItem-root": {
            "& .MuiListItemText-root .MuiTypography-root": {
              fontSize: "10px",
              fontFamily: "PoppinsBold, sans-serif",
            },
            "& .MuiListItemAvatar-root": {
              minWidth: 22,
            },
            "& .MuiAvatar-root ": {
              width: 22,
              height: 22,
              marginRight: CaladreTheme.spacing(0.8),
              backgroundColor: CaladreTheme.palette.primary.main,
              "& .MuiSvgIcon-root": {
                fontSize: "14px",
                transition: "all 0.2s ease-in-out",
                "&:hover": {
                  transform: "scale(1.1)",
                },
              },
            },
          },
        },
      },
    },
  },
  rotate: {
    transform: "rotate(90deg)",
  },
  messagerie: {
    "& .MuiGrid-item": {
      padding: CaladreTheme.spacing(3),
    },
    "& .MuiListItem-root": {
      paddingLeft: 0,
      "&:hover": {
        cursor: "pointer",
      },
    },
    "& .MuiCard-root": {
      display: "flex",
      borderRadius: "12px",
      margin: CaladreTheme.spacing(3, 0),
      "&:hover": {
        cursor: "pointer",
      },
      "& .MuiCardMedia-root": {
        width: 72,
        height: 60,
      },
      "& .MuiBox-root": {
        paddingLeft: CaladreTheme.spacing(1)
      },
    },
  },
  chat: {
    "& .MuiCard-root": {
      background: "none",
      boxShadow: "none",
      display: "flex",
      borderRadius: "12px",
      margin: CaladreTheme.spacing(3, 0),
      "&:hover": {
        cursor: "pointer",
      },
      "& .MuiTypography-h5": {
        fontSize: "12px !important",
      },
      "& .MuiTypography-body2": {
        fontSize: "10px !important",
      },
      "& span": {
        marginLeft: CaladreTheme.spacing(1),
        fontSize: "9px !important",
        fontWeight: "normal",
      },
    },
  },
  msgZone: {
    my: 2,
    "& .MuiInputBase-root": {
      width: "100%",
      padding: CaladreTheme.spacing(1, 1),
      backgroundColor: "#E8E7E7",
      borderRadius: "12px",
      "& .MuiInputBase-input": {
        fontSize: "12px",
        padding: `${CaladreTheme.spacing(1, 1)} !important`,
      },
    },
    "& .MuiButton-root": {
      fontSize: "10px",
      marginTop: CaladreTheme.spacing(1),
    },
  },
  selectedItem: {
    backgroundColor: "#E8E7E7",
  },
  reportMsg: {
    color: CaladreTheme.palette.info.main,
    fontSize: "10px",
    cursor: "pointer",
  },
};
export default classes;
